import qs from 'qs';



export const parseQueryString= function (str){
    const search = qs.parse(str, { ignoreQueryPrefix: true });

    return search;
}